// RETTERBOX product-card.js — AJAX add-to-cart + qty stepper
// Delegates to Dawn's <cart-drawer> custom element; never replaces cart-drawer.js.

(function () {
  'use strict';

  // ── Add to cart via .js-add-to-cart button ─────────────────────────
  // Matches prototype: adds item + toast, then the card swaps the button for
  // the qty stepper (via refreshSteppers on cart:updated). Does NOT open the drawer.
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.js-add-to-cart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = '…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify((function () {
          var pr = {};
          if (btn.dataset.pfand) pr._pfand = btn.dataset.pfand;
          if (btn.dataset.ve) pr._ve = btn.dataset.ve;
          if (btn.dataset.maxQty && parseInt(btn.dataset.maxQty, 10) > 0) pr._max_qty = btn.dataset.maxQty;
          if (btn.dataset.cmp && parseInt(btn.dataset.cmp, 10) > 0) pr._cmp = btn.dataset.cmp;
          var o = { id: variantId, quantity: 1 };
          if (Object.keys(pr).length) o.properties = pr;
          return o;
        })())
      });
      if (!res.ok) throw new Error(await res.text());

      // Sync cart state → refreshSteppers shows the qty stepper on this card
      const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      // Toast only — no drawer open (prototype behaviour)
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: 'In den Warenkorb gelegt ✓' } }));

      btn.disabled = false;
      btn.textContent = original;
    } catch (err) {
      console.error('RETTERBOX: Add to cart failed', err);
      btn.textContent = 'Fehler';
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
    }
  });

  // ── Legacy data-add-to-cart support (old markup) ───────────────────
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = '…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify((function () {
          var pr = {};
          if (btn.dataset.pfand) pr._pfand = btn.dataset.pfand;
          if (btn.dataset.ve) pr._ve = btn.dataset.ve;
          if (btn.dataset.maxQty && parseInt(btn.dataset.maxQty, 10) > 0) pr._max_qty = btn.dataset.maxQty;
          if (btn.dataset.cmp && parseInt(btn.dataset.cmp, 10) > 0) pr._cmp = btn.dataset.cmp;
          var o = { id: variantId, quantity: 1 };
          if (Object.keys(pr).length) o.properties = pr;
          return o;
        })())
      });
      if (!res.ok) throw new Error(await res.text());

      const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      if (window.RB_openCart) window.RB_openCart();
      else document.dispatchEvent(new CustomEvent('cart:open'));

      document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: 'In den Warenkorb gelegt ✓' } }));

      btn.textContent = '✓ Hinzugefügt';
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
    } catch (err) {
      console.error('RETTERBOX: Add to cart failed', err);
      btn.textContent = 'Fehler';
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
    }
  });

  // ── Qty stepper on cards (rb-pcstep) ──────────────────────────────
  function refreshSteppers(cart) {
    const items = cart && cart.items ? cart.items : [];
    const qtyMap = {};
    items.forEach(function (item) { qtyMap[item.variant_id] = item.quantity; });

    document.querySelectorAll('.rb-pcwrap').forEach(function (wrap) {
      const stepper = wrap.querySelector('.rb-pcstep');
      if (!stepper) return;
      const vid = parseInt(stepper.dataset.variantId, 10);
      const qty = qtyMap[vid] || 0;

      if (qty > 0) {
        wrap.classList.add('rb-pcwrap--q');
        const qtyEl = stepper.querySelector('[data-pcstep-qty]');
        if (qtyEl) qtyEl.textContent = qty;
      } else {
        wrap.classList.remove('rb-pcwrap--q');
      }
    });
  }

  document.addEventListener('cart:updated', function (e) {
    refreshSteppers(e.detail);
  });

  document.addEventListener('click', async function (e) {
    const stepBtn = e.target.closest('[data-pcstep-dec],[data-pcstep-inc]');
    if (!stepBtn) return;
    e.preventDefault();
    e.stopPropagation();

    const card = stepBtn.closest('.rb-pcwrap');
    if (!card) return;
    const stepper = card.querySelector('.rb-pcstep');
    const variantId = stepper ? parseInt(stepper.dataset.variantId, 10) : 0;
    if (!variantId) return;

    const isInc = stepBtn.hasAttribute('data-pcstep-inc');

    if (stepper.dataset.busy === '1') return; // ignore rapid double-clicks mid-request
    stepper.dataset.busy = '1';

    try {
      // Read the authoritative current qty + line key from the live cart
      let cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      const line = cart.items.find(function (i) { return i.variant_id === variantId; });
      const current = line ? line.quantity : 0;
      const newQty = isInc ? current + 1 : Math.max(0, current - 1);

      // Change by line key when the item exists (most reliable); else add.
      if (line) {
        cart = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: newQty })
        }).then(function (r) { return r.json(); });
      } else if (isInc) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify((function () {
          var pr = {};
          if (btn.dataset.pfand) pr._pfand = btn.dataset.pfand;
          if (btn.dataset.ve) pr._ve = btn.dataset.ve;
          if (btn.dataset.maxQty && parseInt(btn.dataset.maxQty, 10) > 0) pr._max_qty = btn.dataset.maxQty;
          if (btn.dataset.cmp && parseInt(btn.dataset.cmp, 10) > 0) pr._cmp = btn.dataset.cmp;
          var o = { id: variantId, quantity: 1 };
          if (Object.keys(pr).length) o.properties = pr;
          return o;
        })())
        });
        cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (err) {
      console.error('RETTERBOX: stepper update failed', err);
    } finally {
      stepper.dataset.busy = '';
    }
  });

  // ── Quick-view trigger on card (whole rb-pcwrap clickable) ─────────
  // Ignore clicks on interactive controls so they keep working without opening the modal.
  document.addEventListener('click', function (e) {
    if (e.target.closest('button, a, input, select, .rb-pcstep, .rbx-pcard__fav, .js-add-to-cart, [data-add-to-cart]')) return;
    const trigger = e.target.closest('[data-quickview]');
    if (!trigger) return;
    const handle = trigger.dataset.handle;
    if (!handle) return;
    // Preselect the same variant the card shows (e.g. the bundle pack) in the modal.
    const card = trigger.querySelector('[data-variant-id]');
    const variant = card ? card.getAttribute('data-variant-id') : null;
    document.dispatchEvent(new CustomEvent('quickview:open', { detail: { handle: handle, variant: variant } }));
  });

  // ── Carousel scroll arrows ──────────────────────────────────────────
  document.querySelectorAll('[data-car-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const track = document.querySelector(btn.dataset.carPrev);
      if (track) track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
    });
  });
  document.querySelectorAll('[data-car-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const track = document.querySelector(btn.dataset.carNext);
      if (track) track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

})();
